import styled from '@emotion/styled';

import { palette, remCalc } from '../../css';

const StyledImage = styled('img')(() => ({
    width: '100%',
    height: 'auto',
}));

const StyledImageWrapper = styled('div')(() => ({
    position: 'relative',
}));

const StyledCopyright = styled('div')(
    () => ({
        position: 'absolute',
        color: palette('white'),
        padding: remCalc(15, 20),
    }),
    ({ position }) => {
        switch (position) {
            case 'top-left':
                return {
                    top: 0,
                    left: 0,
                    paddingRight: remCalc(70),
                    paddingBottom: remCalc(70),

                    backgroundImage: `linear-gradient(325deg, transparent 50%, ${palette(
                        'grey',
                        'xxxDarkAlpha',
                    )} 100%)`,
                };
            case 'bottom-left':
                return {
                    bottom: 0,
                    left: 0,
                    paddingRight: remCalc(70),
                    paddingTop: remCalc(70),

                    backgroundImage: `linear-gradient(-145deg, transparent 50%, ${palette(
                        'grey',
                        'xxxDarkAlpha',
                    )} 100%)`,
                };

            case 'top-right':
                return {
                    top: 0,
                    right: 0,
                    paddingLeft: remCalc(70),
                    paddingBottom: remCalc(70),

                    backgroundImage: `linear-gradient(-325deg, transparent 50%, ${palette(
                        'grey',
                        'xxxDarkAlpha',
                    )} 100%)`,
                };
            case 'bottom-right':
            default:
                return {
                    bottom: 0,
                    right: 0,
                    paddingLeft: remCalc(70),
                    paddingTop: remCalc(70),

                    backgroundImage: `linear-gradient(145deg, transparent 50%, ${palette(
                        'grey',
                        'xxxDarkAlpha',
                    )} 100%)`,
                };
        }
    },
);

export { StyledImage, StyledImageWrapper, StyledCopyright };
